import script from "./Resource.vue?vue&type=script&lang=ts&setup=true"
export * from "./Resource.vue?vue&type=script&lang=ts&setup=true"

import "./Resource.vue?vue&type=style&index=0&id=50f7c8ff&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f7c8ff"]])

export default __exports__